module.exports = __webpack_public_path__ + "static/media/new-troc-cabriolet.83dd95a7.png";